export default __webpack_public_path__ + "static/media/gaming_Footer_Netent_Supplier.3a5418a0.svg";